<template>
    <div class="col-12 col-md-6 col-lg-3">
        <div class="card-custom-payment" :class="getBackgroundColor(icon)">
            <div class="card-custom-payment-right">
                <div class="card-custom-payment-right-title">
                    S/.{{ total }}
                </div>
                <div class="card-custom-payment-right-subtitle">
                    {{ title }}
                </div>
            </div>
            <div v-html="renderIcon(icon)"></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['total', 'title', 'icon'],
        methods: {
            getBackgroundColor(icon) {
                if (icon === 'paid') {
                    return `bg-success`
                }
                if (icon === 'pending') {
                    return `bg-new-warning`
                }
                if (icon === 'defeated') {
                    return `bg-danger`
                }
                if (icon === 'voided') {
                    return `bg-voided`
                }
                return ''
            },
            renderIcon(icon) {
                if (icon === 'paid') {
                    return `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24"><path fill="currentColor" d="M19 9.09V6c0-.55-.45-1-1-1h-3.09L12.7 2.79a.996.996 0 0 0-1.41 0L9.08 5H5.99c-.55 0-1 .45-1 1v3.09L2.78 11.3a.996.996 0 0 0 0 1.41l2.21 2.21v3.09c0 .55.45 1 1 1h3.09l2.21 2.21c.2.2.45.29.71.29s.51-.1.71-.29l2.21-2.21h3.09c.55 0 1-.45 1-1v-3.09l2.21-2.21a.996.996 0 0 0 0-1.41l-2.21-2.21Zm-1.71 4.71a1 1 0 0 0-.29.71v2.5h-2.5c-.27 0-.52.11-.71.29L12 19.09l-1.79-1.79a1 1 0 0 0-.71-.29H7v-2.5c0-.27-.11-.52-.29-.71l-1.79-1.79l1.79-1.79A1 1 0 0 0 7 9.51v-2.5h2.5c.27 0 .52-.11.71-.29L12 4.93l1.79 1.79c.19.19.44.29.71.29H17v2.5c0 .27.11.52.29.71l1.79 1.79z"/><path fill="currentColor" d="m11 12.59l-1.29-1.3l-1.42 1.42l2.71 2.7l4.71-4.7l-1.42-1.42z"/></svg>`
                }
                if (icon === 'pending') {
                    return `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24"><path fill="currentColor" d="M17 3.34a10 10 0 1 1-14.995 8.984L2 12l.005-.324A10 10 0 0 1 17 3.34M12 6a1 1 0 0 0-.993.883L11 7v5l.009.131a1 1 0 0 0 .197.477l.087.1l3 3l.094.082a1 1 0 0 0 1.226 0l.094-.083l.083-.094a1 1 0 0 0 0-1.226l-.083-.094L13 11.585V7l-.007-.117A1 1 0 0 0 12 6"/></svg>`
                }
                if (icon === 'defeated') {
                    return `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24"><g class="warning-outline"><g fill="currentColor" class="Vector"><path fill-rule="evenodd" d="M12 13.8a1 1 0 0 1-1-1v-5a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1" clip-rule="evenodd"/><path d="M10.947 15.958a1.053 1.053 0 1 1 2.106 0a1.053 1.053 0 0 1-2.106 0"/><path fill-rule="evenodd" d="m15.607 4.642l5.876 10.72c1.512 2.759-.473 6.138-3.607 6.138H6.124c-3.134 0-5.12-3.38-3.607-6.139l5.876-10.72c1.566-2.855 5.648-2.855 7.214 0Zm-1.804 1c-.782-1.429-2.824-1.429-3.606 0L4.32 16.36c-.757 1.38.236 3.069 1.803 3.069h11.752c1.567 0 2.56-1.69 1.803-3.07z" clip-rule="evenodd"/></g></g></svg>`
                }
                if (icon === 'voided') {
                    return `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24"><path fill="currentColor" d="M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0M5.29 5.29a9.63 9.63 0 0 1 12.23-1a.26.26 0 0 1 0 .4L4.67 17.56a.27.27 0 0 1-.4 0a9.49 9.49 0 0 1 1-12.24Zm13.46 13.47a9.53 9.53 0 0 1-12.23 1a.26.26 0 0 1 0-.4L19.37 6.49a.26.26 0 0 1 .4 0a9.49 9.49 0 0 1-1 12.24Z"/></svg>`
                }
                return ''
            }
        },
    }
</script>

<style>
    .card-custom-payment {
        border-radius: 15px;
        padding: 25px 20px;
        margin: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: rgba(255, 255, 255, .8);
    }

    .card-custom-payment-right {
        display: flex;
        flex-direction: column;
        gap: 1px;
    }

    .card-custom-payment-right-title {
        font-weight: 500;
        font-size: 22px;
    }

    .card-custom-payment-right-subtitle {
        font-weight: 300;
        font-size: 15px;
    }

    .bg-voided {
        background-color: #777777e5;
    }
</style>


// WEBPACK FOOTER //
// resources/js/views/system/payments/components/card.vue